module.exports = __webpack_public_path__ + "public/img/detail.975df6f7.png";